
const AcceptBtn = ({ acceptHandler, text }) => {

    return (
        <button onClick={() => acceptHandler()} className="bg-primary text-white rounded-lg outline-none px-3 py-2 flex items-center gap-x-2 hover:bg-blue-700/90">
            <p>
                {text}
                </p>
        </button>
    )
}

export default AcceptBtn